export enum UnitEnum {
  GRAM = 'GRAM',
  KILOGRAM = 'KILOGRAM',
  MILLILITER = 'MILLILITER',
  LITER = 'LITER',
  UNIT = 'UNIT',
  THOUSAND = 'THOUSAND',
}

export const UnitMapping = {
  [UnitEnum.GRAM]: {
    name: 'G',
  },
  [UnitEnum.KILOGRAM]: {
    name: 'KG',
  },
  [UnitEnum.MILLILITER]: {
    name: 'ML',
  },
  [UnitEnum.LITER]: {
    name: 'L',
  },
  [UnitEnum.UNIT]: {
    name: 'Unidade',
  },
  [UnitEnum.THOUSAND]: {
    name: 'Mil',
  },
};
